<script setup>
import NavLink from '@/Components/NavLink.vue';
import {
    UsersIcon,
    BanknotesIcon,
    ClipboardDocumentCheckIcon,
    EllipsisHorizontalIcon,
    HeartIcon,
    CalendarIcon,
    BookOpenIcon,
    MagnifyingGlassIcon
} from '@heroicons/vue/24/outline';
import SavingIndicator from '@/Components/SavingIndicator.vue';
import DressIcon from '@/Icons/DressIcon.vue';
import ActionButtons from './ActionButtons.vue';

const props = defineProps({
    isGuest: Boolean | undefined,
    actionButtons: {
        type: Array,
        default: () => []
    }
});
</script>

<template>
    <!--Background of whole page-->
    <SavingIndicator />
    <div class="min-h-screen flex justify-center bg-white">
        <!--Background of app area (pb ensures app content always ends above navbar)-->
        <div class="relative min-h-full w-full md:max-w-4xl bg-white pb-12">
            <!--App content-->
            <slot />
        </div>
        <div class="fixed bottom-20 right-2 md:right-1/3 md:mr-4 z-40">
            <ActionButtons :actionButtons="actionButtons" />
        </div>
        <nav
            class="fixed bottom-0 left-0 right-0 w-full md:max-w-2xl md:left-1/2 md:right-auto md:-translate-x-1/2 md:rounded-t flex justify-between py-3 px-2 md:px-6 z-40 shadow-lg text-gray-500 border-t-2 border-gray-100 backdrop-blur-lg bg-white"
        >
            <NavLink
                cy-test="tasks-navLink"
                :href="route('tasks.index')"
                :active="route().current('tasks.*') || route().current('landing.tasks')"
            >
                <ClipboardDocumentCheckIcon class="w-6 h-6"></ClipboardDocumentCheckIcon>
                Checklist
            </NavLink>
            <NavLink
                cy-test="budget-navLink"
                :href="route('budget.index')"
                :active="route().current('budget.*') || route().current('items.*') || route().current('landing.budget')"
            >
                <BanknotesIcon class="w-6 h-6"></BanknotesIcon>
                Budget
            </NavLink>
            <NavLink
                cy-test="guests-navLink"
                :href="route('guests.index')"
                :active="route().current('guests.*') || route().current('landing.guests')"
            >
                <UsersIcon class="w-6 h-6"></UsersIcon>
                Guests
            </NavLink>
            <a
                class="flex flex-col items-center px-1 pt-1 text-xs font-medium leading-5 text-gray-500 hover:text-gray-700 focus:outline-hidden focus:text-gray-700 focus:border-gray-300 active:text-theme-600"
                :href="route('filament.public.pages.nz-wedding-directory')"
                :active="route().current('public.*')"
            >
                <MagnifyingGlassIcon class="w-6 h-6" />
                Directory
            </a>
            <NavLink :href="route('dresses.index')" :active="route().current('dresses.*')">
                <DressIcon class="w-6 h-6"></DressIcon>
                The dress
            </NavLink>
            <a
                class="hidden md:flex flex-col items-center px-1 pt-1 text-xs font-medium leading-5 text-gray-500 hover:text-gray-700 focus:outline-hidden focus:text-gray-700 focus:border-gray-300 active:text-theme-600"
                :href="route('filament.user.resources.events.index')"
                :active="route().current('events.*')"
            >
                <CalendarIcon class="w-6 h-6"></CalendarIcon>
                Events
            </a>
            <NavLink class="hidden md:block" :href="route('blog.index')" :active="route().current('blog.*')">
                <BookOpenIcon class="w-6 h-6"></BookOpenIcon>
                Blog
            </NavLink>
            <NavLink cy-test="login-navLink" v-if="isGuest" :href="route('login')" :active="route().current('login')">
                <HeartIcon class="w-6 h-6"></HeartIcon>
                Login
            </NavLink>
            <NavLink cy-test="more-navLink" v-else :href="route('more.index')" :active="route().current('more.*')">
                <EllipsisHorizontalIcon class="w-6 h-6"></EllipsisHorizontalIcon>
                More
            </NavLink>
        </nav>
    </div>
</template>
